import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'general-modal',
  templateUrl: './general-modal.component.html',
  styleUrls: ['./general-modal.component.scss'],
  standalone: false,
})
export class GeneralModalComponent implements OnInit {
  @Input() item: any;
  public settings: any;
  private appSettingsSubscription: Subscription;

  constructor(private modalController: ModalController, private router: NavController) {}

  ngOnInit() {
    // if (this.isSquare ==  true) {
    //   this.sizeVar = "squareTrue"
    // } else {
    //   this.sizeVar = "squareFalse"
    // }
  }

  /**
   * Dismisses the modal.
   */
  async dismiss() {
    await this.modalController.dismiss();
  }

  /**
   * Handles the "Learn More" button click.
   * You can add navigation or other logic here.
   */
  learnMore() {
    // Example: You might want to dismiss the modal and then navigate
    this.dismiss();
    // this.router.navigateRoot(['/subscription-list']);
  }
}
